import { User } from 'state/user/UserState'

const hasPermission = (user: User | undefined, permission: string) => {
    return !!user?.permissions?.includes(permission)
}

export default hasPermission
